// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__370ZQ","col":"styles_col__1QmXe"};